import { ReactNode } from 'react';
import { Feature } from '../../../../../types/CompanyDtos';
import r from '../../../../react/services/Replacement';
import AlertBox from '../../AlertBox';
import Link from '../../Link';
import UpgradePlanOnHover from '../../UpgradePlanOnHover';

type FeaturesLinksTypeDef = {
    documentationLink: string;
    label: string;
};
type FeaturesLinksType = Partial<Record<Feature, FeaturesLinksTypeDef>>;

const featuresLinks = {
    FEATURE_objectiveCascading: {
        documentationLink: 'https://learn.small-improvements.com/cascading-objectives-2025',
        label: `Cascading ${r('objective.plural.big')}`,
    },
    FEATURE_cycleAdmins: {
        documentationLink: 'https://resources.small-improvements.com/knowledge-base/cycle-admins/',
        label: `Cycle admins`,
    },
} as const satisfies FeaturesLinksType;

type SupportedFeatures = keyof typeof featuresLinks;

interface Props {
    showTooltip: boolean;
    tootlipContent?: ReactNode;
    alertContent?: string;
    feature: SupportedFeatures;
}

const UpgradePlanAlert = ({ showTooltip, tootlipContent, alertContent, feature }: Props) => {
    const baseTooltipContent = (
        <>
            The {featuresLinks[feature].label} feature is a premium feature that's not available on your current pricing
            plan. You can learn more about the feature in{' '}
            <Link href={featuresLinks[feature].documentationLink} target="_blank">
                our documentation.
            </Link>{' '}
            Reach out to <Link href="mailto:support@small-improvements.com">support@small-improvements.com</Link> to
            discuss upgrade options.
        </>
    );
    return (
        <UpgradePlanOnHover
            show={showTooltip}
            content={tootlipContent ? tootlipContent : baseTooltipContent}
            hideUpgradeOptionsLink
        >
            <AlertBox colour="PURPLE" compact>
                {alertContent ? alertContent : 'Premium feature'}
            </AlertBox>
        </UpgradePlanOnHover>
    );
};

export default UpgradePlanAlert;
